export const LOCATION_SEARCH_PREFIX = "Where are you staying?";
export const LOADING_TEXT = "Loading";
export const CONTINUE = "Continue";
